import React from "react";
import MutationLayout from "../components/MutationLayout";
import {
    useGetCustomerGroupQuery,
    useUpdateCustomerGroupMutation,
} from "@redux/features/customerGroups/customerGroupsApi";
import { useHistory, useParams } from "react-router-dom";
import BaseRecordRenderer from "@reusables/BaseRecordRenderer";
import { isErrorWithMessage } from "@redux/api/query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BaseLoadingBlocker } from "@reusables/blockers/BaseLoadingBlocker";
import { Can } from "@/casl.config";
import NoPermissionBanner from "@/components/ErrorPages/NoPermissionBanner";

export default function CustomerGroupEditingPage() {
    const { t } = useTranslation("", { keyPrefix: "customerGroups.editing" });

    const history = useHistory();
    const { id } = useParams<{ id: string }>();

    const { data: customerGroup, isLoading: customerGroupLoading } = useGetCustomerGroupQuery(
        parseInt(id)
    );

    const [updateCustomerGroup, { isLoading: isUpdatingLoading }] =
        useUpdateCustomerGroupMutation();

    return (
        <>
            <Can not I="edit" a="customer">
                <div className="levitation-extended">
                    <NoPermissionBanner />
                </div>
            </Can>

            <Can I="edit" a="customer">
                <BaseRecordRenderer record={customerGroup} loading={customerGroupLoading}>
                    <BaseLoadingBlocker active={isUpdatingLoading}>
                        <div className="space-y-[40px]">
                            <div className="text-2xl text-accent font-bold">
                                {customerGroup?.name}
                            </div>
                            <MutationLayout
                                customerGroup={customerGroup}
                                onSubmit={(data) => {
                                    updateCustomerGroup({
                                        id: customerGroup?.id as number,
                                        ...data,
                                    })
                                        .unwrap()
                                        .then((resp) => {
                                            history.push(
                                                `/dashboard/customer-groups/${resp.id}/details`
                                            );

                                            toast.success(t("responses.success"));
                                        })
                                        .catch((e) => {
                                            if (isErrorWithMessage(e)) {
                                                toast.error(e.message);
                                            } else {
                                                toast.error(t("responses.error"));
                                            }
                                        });
                                }}
                            />
                        </div>
                    </BaseLoadingBlocker>
                </BaseRecordRenderer>
            </Can>
        </>
    );
}
